// We are disabling turbo on forms by default unless we provide a data-turbo=true for specific forms
// This will help with the migration to Turbo especially while we keep UJS around.
Turbo.config.forms.mode = 'optin';
